<template>
  <div>
    <el-dialog width="600px"
               title="短信购买"
               :visible.sync="viewDetail"
               @close="closeModel">
      <el-card class="box-card">
        <p style="padding:20px 30px 30px 30px">单价：0.06元/条</p>
        <el-row :gutter="20"
                v-loading="loading">
          <el-col :span="2.5">
            购买条数：
          </el-col>
          <el-col :span="21.5">
            <el-radio-group v-model="radio"
                            v-for="item in comboList"
                            :key="item.id">
              <p class="radioP">
                <el-radio :label="item.id"
                          @change="chooseFn(item)">
                  <!--  <span>1000条</span>&nbsp;&nbsp; -->
                  <span style="color:red">{{item.name}}</span>
                </el-radio>
                <!-- <el-radio :label="2">
                  <span>5000条</span>&nbsp;&nbsp;
                  <span style="color:red">￥300</span>
                </el-radio> -->
              </p>
              <!--  <p class="radioP">
                <el-radio :label="3"><span>1万条</span>&nbsp;&nbsp;<span style="color:red">￥600</span></el-radio>
                <el-radio :label="4"><span>3万条</span>&nbsp;&nbsp;<span style="color:red">￥1800</span></el-radio>>
              </p> -->

            </el-radio-group>
          </el-col>

        </el-row>
        <p style="padding:10px 30px 30px 30px">
          <el-checkbox v-model="checked"><span style="color:blue">《短信营销服务使用规范》</span></el-checkbox>
        </p>
        <div class="btns">
          <!-- @click="showPay(item.id)" -->
          <el-button type="primary"
                     class="primary"
                     :disabled="checked==false"
                     @click="showPay">购 买</el-button>
          <el-button type="info"
                     class="primary">取 消</el-button>
        </div>
      </el-card>
    </el-dialog>
    <payAction ref="payAction"
               :id="appId"
               :combo_id="radio"
               :price_id="price_id"></payAction>
  </div>
</template>

<script>
import {
  mapActions,
  mapGetters
} from "vuex";
import payAction from './payAction.vue'
export default {
  props: ['appId'],
  data () {
    return {
      viewDetail: false,
      radio: '',
      checked: true,
      price_id: '',
      comboList: [],
      loading: false

    };
  },
  computed: {
    ...mapGetters(["getToken"]),
  },
  //applicationCombo
  methods: {
    chooseFn (val) {
      this.price_id = val.amount
      console.log(val, '------')
    },
    getCombo () {
      this.loading = true
      let params = {
        id: 10,
        token: this.getToken,
      };
      this.applicationCombo(params).then(({
        data
      }) => {
        this.loading = false
        if (data.code == 1) {
          this.comboList = data.data;
          console.log(this.comboList, 'this.comboList----')
          // this.comboList = [...data.data, ...data.data, ...data.data];
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    ...mapActions({
      applicationCombo: "detect/applicationCombo",
    }),
    showPay () {
      if (this.radio == "") {
        this.$message.error('请勾选你需要购买的套餐')
      } else {
        this.$refs.payAction.viewDetail = true
        console.log(this.appId, 'this.appId---')
        this.$refs.payAction.getPayId(this.radio, this.appId)
      }


    },
    closeModel () {
      this.viewDetail = false
    }

  },
  components: {
    payAction
  },
};
</script>

<style lang="scss" scoped>
.el-radio-group {
  width: 300px;

  // border: 1px solid #ccc;
}

.el-radio {
  width: 120px;
}

.radioP {
  padding: 20px 0 20px 80px;
}
.btns {
  text-align: center;
  .el-radio {
    padding: 10px 40px;
  }
}
</style>
